import { BffGamesCategory } from '@lucky7ventures/bff-types';

export enum LastPlayedCategory {
  LastPlayed = 'last-played',
}

export type GamesCategories = BffGamesCategory | LastPlayedCategory;
